// src/App.tsx

import { Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';

import RootLayout from './components/layouts/RootLayout';
import { LoginPage } from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import { SuccessPage } from './pages/SuccessPage';
import VerifyRoute from './routes/VeridyRoute';
import { GoogleOAuthProvider } from '@react-oauth/google';
import CommunityLayout from './components/community/layout/CommunityLayout';
import Community from './pages/community/Community';
import { useAuthStore } from './auth/auth.store';

// Guards

import PublicOnlyRoute from './guards/PublicOnlyRoute';
import ProtectedRoute from './guards/ProtectedRoute';
import ProfilePage from './pages/community/ProfilePage';


// import RoleRoute from './auth/RoleRoute';

function AuthSessionBootstrap() {
    const fetchCurrentUser = useAuthStore((state) => state.fetchCurrentUser);
    useEffect(() => {
        void fetchCurrentUser();
    }, [fetchCurrentUser]);
    return null;
}

export default function App() {
    const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
    const googleProvider = (el: React.ReactNode) => (
        <GoogleOAuthProvider clientId={googleClientId || 'google-client-id-missing'}>
            {el}
        </GoogleOAuthProvider>
    );

    return (
        <>
            <AuthSessionBootstrap />
            <Routes>
                <Route element={<RootLayout />}>

                    {/* ============ PUBLIC — anyone ============ */}
                    <Route element={<CommunityLayout />}>
                        <Route index element={<Community />} />
                    </Route>

                    {/* ============ GUEST-ONLY — logged-in users are bounced ============ */}
                    <Route element={<PublicOnlyRoute redirectTo="/" />}>
                        <Route path="/login"    element={googleProvider(<LoginPage />)} />
                        <Route path="/register" element={googleProvider(<SignupPage />)} />
                        <Route path="/verify"   element={googleProvider(<VerifyRoute />)} />
                        <Route path="/success"  element={<SuccessPage />} />
                    </Route>

                    {/* ============ AUTH-ONLY — guests are bounced to /login ============ */}
                    <Route element={<ProtectedRoute />}>
                        {/* Example: dashboard */}
                        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
                        <Route
                            path="community/profile/:id"
                            element={
                                <ProfilePage />
                            }
                        />
                    </Route>

                    {/* ============ ROLE-RESTRICTED (optional) ============ */}
                    {/* <Route element={<RoleRoute roles={['admin', 'superadmin']} />}>
                        <Route path="/admin" element={<AdminDashboard />} />
                    </Route> */}

                </Route>
            </Routes>
        </>
    );
}